"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UNIT_OPTIONS = exports.TODAY = exports.PLACEHOLDER_TEXT = exports.NOTE_TYPE_VALUES = exports.NOTE_TYPE_OPTIONS = exports.INTERACTION_TYPE_VALUES = exports.INTERACTION_TYPE_OPTIONS = exports.DEFAULT_NOTE_TYPE = exports.DEFAULT_INTERACTION_TYPE = exports.DEFAULT_ATTACHED_TO = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var INTERACTION_TYPE_VALUES = exports.INTERACTION_TYPE_VALUES = {
  PHONE: 'phone_call',
  EMAIL: 'email',
  MEETING: 'meeting'
};
var INTERACTION_TYPE_OPTIONS = exports.INTERACTION_TYPE_OPTIONS = [{
  label: 'Phone',
  value: INTERACTION_TYPE_VALUES.PHONE
}, {
  label: 'Email',
  value: INTERACTION_TYPE_VALUES.EMAIL
}, {
  label: 'In Person',
  value: INTERACTION_TYPE_VALUES.MEETING
}];

// this is to be deprecated in favor of src/components/Notes/constants variables
// we can use this reference constant but those values reflect the source of truth
var NOTE_TYPE_VALUES = exports.NOTE_TYPE_VALUES = {
  GENERAL: 'note',
  INTERACTION: 'interaction',
  PROVIDED_SERVICE: 'provided_service'
};
var NOTE_TYPE_OPTIONS = exports.NOTE_TYPE_OPTIONS = [{
  label: 'General',
  value: NOTE_TYPE_VALUES.GENERAL
}, {
  label: 'Interaction',
  value: NOTE_TYPE_VALUES.INTERACTION
}, {
  label: 'Service Provided',
  value: NOTE_TYPE_VALUES.PROVIDED_SERVICE
}];
var UNIT_OPTIONS = exports.UNIT_OPTIONS = [{
  label: 'Dollar Amount ($)',
  value: 'dollar'
}, {
  label: 'Hours',
  value: 'hours'
}, {
  label: 'Units/Items',
  value: 'units per item'
}];
var TODAY = exports.TODAY = (0, _moment["default"])().startOf('day').format('X');
var PLACEHOLDER_TEXT = exports.PLACEHOLDER_TEXT = 'Add your note here';
var DEFAULT_ATTACHED_TO = exports.DEFAULT_ATTACHED_TO = 'general';
var DEFAULT_INTERACTION_TYPE = exports.DEFAULT_INTERACTION_TYPE = INTERACTION_TYPE_VALUES.PHONE;
var DEFAULT_NOTE_TYPE = exports.DEFAULT_NOTE_TYPE = NOTE_TYPE_VALUES.GENERAL;
var _default = exports["default"] = {
  DEFAULT_ATTACHED_TO: DEFAULT_ATTACHED_TO,
  DEFAULT_INTERACTION_TYPE: DEFAULT_INTERACTION_TYPE,
  DEFAULT_NOTE_TYPE: DEFAULT_NOTE_TYPE,
  INTERACTION_TYPE_OPTIONS: INTERACTION_TYPE_OPTIONS,
  INTERACTION_TYPE_VALUES: INTERACTION_TYPE_VALUES,
  NOTE_TYPE_OPTIONS: NOTE_TYPE_OPTIONS,
  NOTE_TYPE_VALUES: NOTE_TYPE_VALUES,
  PLACEHOLDER_TEXT: PLACEHOLDER_TEXT,
  TODAY: TODAY,
  UNIT_OPTIONS: UNIT_OPTIONS
};